import { rawApi, API } from "@/lib/offline/net";
import { wrappedGet, wrappedGetCached, wrappedMutate, initOffline } from "@/lib/offline/sync";

// Offline-first client. GETs read-through an IndexedDB cache; mutations queue in
// an outbox and auto-flush when the connection returns. `api.raw` bypasses all of it.
initOffline();

const api = {
  get: (url, config) => wrappedGet(url, config),
  getCached: (url, onFresh, config) => wrappedGetCached(url, onFresh, config),
  post: (url, body, config) => wrappedMutate("post", url, body, config),
  patch: (url, body, config) => wrappedMutate("patch", url, body, config),
  put: (url, body, config) => wrappedMutate("put", url, body, config),
  delete: (url, config) => wrappedMutate("delete", url, undefined, config),
  raw: rawApi,
};

export const imgUrl = (path, w = 400, q = 80) =>
  `${API}/img?path=${encodeURIComponent(path)}&w=${w}&q=${q}`;

export const photoThumb = (p) =>
  p?.thumb_url || p?.url || (p?.thumbnail_cloud_path || p?.cloud_path ? imgUrl(p.thumbnail_cloud_path || p.cloud_path, 400) : "");
export const photoFull = (p) =>
  p?.url || (p?.cloud_path ? imgUrl(p.cloud_path, 1600, 90) : "");

export { api, API };
